import getSiteUrl from './get-site-url.mjs'
 
const queryAPI = async (
  data,
  key 
) => {
  // const isFormData = data instanceof FormData
  // const body = isFormData ? data : JSON.stringify(data)
  const body  = JSON.stringify(data)
  const base = getSiteUrl()
  const url = `${base}/api/${key}`
  const headers = {} 

  // if (!isFormData) headers['Content-Type'] = 'application/json'
  headers['Content-Type'] = 'application/json'

  try {
    const response = await fetch(
    `${url}`,
    {
      method: 'POST',
      body,
      headers
    }
    )

    return await response.json() 
  } catch (error) {
    console.log(error)
    throw error
  }
 }   

 export default queryAPI 